/**
 * Sessão de dispositivo (JWT de `device_session`, emitido por
 * `POST /events/auth-pin`) rejeitada porque o evento foi invalidado depois
 * que o token foi emitido — HTTP 410, `_reject_if_event_invalidated_after_
 * issuance` no `manager-api` (HUB-21/HUB-235, CA-03).
 *
 * Compartilhado por todo repositório HTTP autenticado com device session
 * (`HttpEventConfigRepository`, `HttpLeadRepository`) — nunca a tela de
 * entrada de PIN, que preserva a mensagem genérica anti-enumeração já
 * existente (`InvalidPinError`, HUB-21).
 *
 * `expiredAt` é o instante em que o cliente detectou a rejeição: o corpo da
 * resposta 410 não devolve o carimbo exato de invalidação do evento.
 */
export class DeviceSessionExpiredError extends Error {
  readonly expiredAt: Date;

  constructor(expiredAt: Date = new Date()) {
    super('Sessão do dispositivo encerrada — evento expirado ou revogado.');
    this.name = 'DeviceSessionExpiredError';
    this.expiredAt = expiredAt;
  }
}
